var path = '/account/sidepanel/systematicPlans/components/systematicPlansLegislativeReqLIF.tpl.html';
var html = "<div ng-if=isLoaded class=subsection> <div class=space /> <dt class=dt-key data-ng-if=visibleFields data-ng-repeat-start=\"field in ::visibleFields\" data-ng-attr-title=\"{{::getLabel({fieldName: field.name})}}\" data-ng-bind=\"::getLabel({fieldName: field.name})\"></dt> <dd class=dt-value data-ng-repeat-end data-ng-class=\"::{'ifds-negative-value' : isNegativeValue({fieldName: field.name})}\" data-ng-bind=\"::getDisplayValue({fieldName: field.name})\"></dd> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/account/sidepanel/systematicPlans/components/systematicPlansLegislativeReqLIF.tpl.html
// module id = 713
// module chunks = 0 2